<template>
  <Modal
    class="cc-modal"
    width="800"
    footer-hide
    v-model="visibility"
    title="我的模板列表"
  >
    <div class="content" v-if="data">
      <div class="row">
        <Input
          v-model="name"
          placeholder="请输入搜索的模板名称"
          style="width: 300px"
          clearable
        />
        <div style="margin-left: 20px">
          <Button type="primary" style="margin-right: 20px" @click="onSearch"
            >搜索</Button
          >
          <Button @click="onSearchCancel">重置</Button>
        </div>
      </div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="name" slot-scope="{ row, index }">
          <div style="display: flex">
            <Radio
              v-model="row.checked"
              @on-change="($evnet) => onRadioChange($evnet, row, index)"
            >
              {{ row.name }}</Radio
            >
          </div>
        </template>
        <template slot="contactsName" slot-scope="{ row }">
          <div>
            {{
              row.type === 0 ? row.locName : row.locBusinessName
            }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button
            shape="circle"
            type="primary"
            style="margin-left: 10px"
            @click="showDetail(row)"
            >查看模板</Button
          >
        </template>
      </Table>
    </div>
    <div class="foot">
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          @on-change="onPageChange"
        />
      </div>
      <div>
        <Button @click="onConfirm" type="primary" style="margin-right: 20px"
          >确定</Button
        >
        <Button @click="onCancel">取消</Button>
      </div>
    </div>
    <!-- 模板详情模态框 -->
    <templateInfoModal
      :show.sync="templateInfoModalVisibility"
      :data="templateInfoModalDetail"
    ></templateInfoModal>
  </Modal>
</template>
<script>
import { templatesList } from "api/domain.js";
import templateInfoModal from "components/template/templateInfoModal.vue";
export default {
  name: "templateListModal",
  components: {
    templateInfoModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableLoading: false,
      columns: [
        {
          title: "模板名称",
          slot: "name",
          align: "center",
        },
        {
          title: "联系人",
          slot: "contactsName",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      name: "",
      page: 1,
      limit: 10,
      total: 0,
      data: [],
      value: {}, // 选中的数据
      templateInfoModalVisibility: false, // 模板详情
      templateInfoModalDetail: {}, // 模板详情数据
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.req_getList();
        }
      },
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  mounted() {
    console.log("mounted");
  },
  beforeDestroy() {
    console.log("beforeDestroy");
  },
  methods: {
    // 获取数据
    async req_getList() {
      try {
        let params = {
          name: this.name,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await templatesList(params);
        this.tableLoading = false;
        if (code === 200) {
          let array = data.list.map((o) => {
            return { ...o, checked: false };
          });
          this.data = array;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 取消
    onCancel() {
      this.visibility = false;
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.name = "";
      this.onPageChange(1);
    },
    // 分页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 选中域名
    onRadioChange(event, val, index) {
      this.value = val;
      this.data.forEach((item, findex) => {
        if (findex !== index) {
          item.checked = false;
        } else {
          item.checked = true;
        }
      });
    },
    // 确定
    onConfirm() {
      this.$emit("onChecked", this.value);
      this.onCancel();
    },
    // 查看详情
    showDetail(val) {
      this.templateInfoModalVisibility = true;
      this.templateInfoModalDetail = val;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .cc-modal {
  .ivu-table-tip td {
    border-bottom: none;
  }
}
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.row {
  display: flex;
  align-items: center;
  line-height: 60px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.page-tool {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
